<template>
  <!-- A simple button component that will open the Micro Modal when it is clicked -->
  <div class="relative">
    <button
      class="button button--panel button--filters js-open-panel button--smd"
      @click="openModal"
    >
      <span class="button__content"
        ><svg
          class="icon icon-plus-circle"
          aria-hidden="true"
          focusable="false"
        >
          <use xlink:href="#icon-plus-circle" />
        </svg>
        Filter By<span class="filters__filters js-filter-filters">
          {{ text }}
        </span></span
      >
    </button>
  </div>
</template>

<script>
import MicroModal from 'micromodal';

export default {
  props: ['selectedColor', 'count', 'loading'],
  computed: {
    text() {
      return this.selectedColor && !this.loading
        ? `/ ${this.selectedColor} / ${this.count} Available`
        : '';
    },
  },
  methods: {
    openModal() {
      MicroModal.show('modal-colors-filters');
    },
  },
};
</script>
